// extracted by mini-css-extract-plugin
export default {"header":"ProductTourHeader_header__J6Rei font-sm-medium"};